import { RootState } from "../store";

export const selectedCurrentUser = (state: RootState) => state.user.currentUser
